import React from 'react';
import IconTint from 'react-icon-tint';
import locpinIcon from '../assets/icons/ic_locpin.svg';

const LocationSelectionGrid = ({
  locations = [],
  selectedLocation,
  onSelect,
  className = '',
  columnsClass = 'grid-cols-3',
  buttonClassName = 'w-[150px]',
  emptyMessage = 'No locations available',
}) => {
  if (locations.length === 0) {
    return (
      <div className={`mt-1 rounded-md bg-[#3C5BD2] bg-opacity-10 px-3 py-2 font-heebo font-light text-gray-600 ${className}`.trim()}>
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className={`grid ${columnsClass} gap-4 mt-1 ${className}`.trim()}>
      {locations.map((item) => {
        const isSelected = selectedLocation === item;

        return (
          <button
            key={item}
            type="button"
            className={`flex items-center p-1 border-l-2 border-l-[#8290F8] ${
              isSelected ? 'bg-[#3C5BD2]' : 'bg-[#DCE0FF]'
            } rounded-l-3xl rounded-r-md cursor-pointer text-left ${buttonClassName}`}
            onClick={() => onSelect(item)}
          >
            <IconTint src={locpinIcon} className="h-5" color={isSelected ? '#FFFFFF' : '#152FF5'} />
            <span className={`ml-2 font-heebo font-light truncate ${isSelected ? 'text-white' : 'text-black'}`}>
              {item}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default LocationSelectionGrid;
